 <template>
     <div class="pd-5 th">
		<b-loading :is-full-page="true" :active.sync="isLoadingPage"></b-loading>
		 <div v-show="interest === false" class="columns is-vcentred">
			<div class="column is-10 mg-x-auto  has-text-right is-paddingless">
				<b-button 
					@click="viewContact"
					size="is-small"
					type="is-primary"
					icon-pack="fas"
					icon-left="comments">
					View contact
            	</b-button>
			</div>
		 </div>
		<div class="columns is-flex-wrap is-vcentred">
			<div class="column is-10 mg-x-auto mg-3">
				<div class="box-page is-flex-wrap columns pd-5">
					<div class="column is-3">
						<label for="uploadfile">
							<div class="circle-img" v-if="companyInvest.profilePic != '' && companyInvest.profilePic != null">
								<img  class="haveimg" :src="imgPath+companyInvest.profilePic" />
							</div>
							<div v-if="companyInvest.profilePic == ''" class="noimg img-size-170">
								<p>170 x 170</p>
							</div>
						</label>
					</div>
					<div class="column is-9">
						<div class="columns is-flex-wrap">
							<div class="column is-9">
								<h3 class="has-text-weight-semibold is-size-4 has-text-dark is-flex is-align-end is-justify-start">Coordinator information</h3>
							</div>
							<div class="column is-12 pd-0">
								<hr class="mg-0">
							</div>
							<div class="column is-6 ">
								<span class="has-text-weight-semibold">Name:</span> {{companyInvest.name}}
							</div> 
							<div class="column is-6">
								<span class="has-text-weight-semibold">Last name:</span> {{companyInvest.surname}}
							</div>   
							<div class="column is-6">
								<span class="has-text-weight-semibold">Position:</span> {{companyInvest.position}}
							</div>  
							<div v-if="interest === true" class="column is-6">
								<span class="has-text-weight-semibold">Telephone Number:</span> {{companyInvest.mobilePhone}}
							</div>  
							<div v-if="interest === true" class="column is-6">
								<span class="has-text-weight-semibold">E-mail:</span> {{companyInvest.email}}
							</div>   
						</div>
					</div>
				</div>
			</div>
			<div class="column is-10 mg-x-auto mg-3">
				<div class="box-page is-flex-wrap columns pd-5">
					<div class="column is-3">
						<label for="uploadfile">
							<div class="square-img" v-if="companyInvest.logo != '' && companyInvest.logo != null">
								<img  class="haveimg" :src="imgPath+companyInvest.logo" />
							</div>
							<div v-if="companyInvest.logo == ''" class="noimg">
								<p>170 x 170</p>
							</div>
						</label>
					</div>
					<div class="column is-9">
						<div class="columns is-flex-wrap">
							<div class="column is-9">
								<h3 class="has-text-weight-semibold is-size-4 has-text-dark is-flex is-align-end is-justify-start">Business information</h3>
							</div>
							<div class="column is-12 pd-0">
								<hr class="mg-0">
							</div>
							<div class="column is-6">
								<span class="has-text-weight-semibold">Name of company or team:</span> {{companyInvest.organizationName}}
							</div>  
							<div v-if="interest === true" class="column is-6">
								<span class="has-text-weight-semibold">Telephone of company or team:</span> {{companyInvest.telephoneNumber}}
							</div>  
							<div v-if="interest === true" class="column is-6">
								<span class="has-text-weight-semibold">Business website:</span> {{(companyInvest.websiteBusiness !== '')?companyInvest.websiteBusiness:'-'}}
							</div>  
							<div class="column is-6">
								<span class="has-text-weight-semibold">Location:</span> {{companyInvest.province}},{{companyInvest.country}}
							</div>    
						</div>
					</div>
				</div>
			</div>
			<div class="column is-10 mg-x-auto mg-3">
				<div class="box-page is-flex-wrap columns pd-5">
					<div class="column is-12 ">
						<div class="columns is-flex-wrap">
							<div class="column is-9">
								<h3 class="has-text-weight-semibold is-size-4 has-text-dark is-flex is-align-end is-justify-start">Product information</h3>
							</div>
							<div class="column is-12 pd-0 ">
								<hr class="mg-0">
							</div>
							<div class="column is-6">
								<span class="has-text-weight-semibold">Business model:</span> {{companyInvest.bizModel}}
							</div> 
							<div class="column is-6">
								<span class="has-text-weight-semibold">Type of business:</span> {{companyInvest.categories}}
							</div>  
							<div class="column is-6">
								<span class="has-text-weight-semibold">Level of business:</span> {{companyInvest.businessLevel}}
							</div>  
							<div v-if="interest === true" class="column is-6">
								<span class="has-text-weight-semibold">Product website:</span> {{(companyInvest.websiteOfProduct !== '')?companyInvest.websiteOfProduct:'-'}}
							</div>    
						</div>
					</div>
				</div>
			</div>
			<div class="column is-10 mg-x-auto mg-3">
				<div class="box-page is-flex-wrap columns pd-5">
					<div class="column is-12 ">
						<div class="columns is-flex-wrap">
							<div class="column is-9">
								<h3 class="has-text-weight-semibold is-size-4 has-text-dark is-flex is-align-end is-justify-start">Introduction</h3>
							</div>
							<div class="column is-12 pd-0 ">
								<hr class="mg-0">
							</div>
							<div class="column is-6">
								<span class="has-text-weight-semibold">About:</span> {{companyInvest.businessInformationEng}} 
							</div>  
							<div class="column is-6">
								<span class="has-text-weight-semibold">Number of employees:</span> {{companyInvest.employee}}
							</div>  
							<div class="column is-12">
								<span class="has-text-weight-semibold">Age Group of your customer:</span> 
								<p class="pd-l-4" v-for="(item,index) in companyInvest.ageCustomerMentor" :key="index">
									{{item.label}}
								</p>
							</div>   
							<div class="column is-12">
								<div >
									<h3 class="has-text-weight-semibold is-size-5 has-text-dark is-flex is-align-end is-justify-start">Target market</h3>	
									<div v-for="(item,index) in companyInvest.taget" :key="index" class="pd-4">
										<div class="is-flex-wrap columns ">
											<div  class="column is-12">			
												<div class="columns is-flex-wrap ">
													<div class="column is-6 pd-y-1 ">
														<span class="has-text-weight-semibold">Target market:</span> {{item.primaryTargetMarketEN}}
													</div> 
													<div class="column is-6 pd-y-1">
														<span class="has-text-weight-semibold">Number of customers:</span> {{item.numberOfCustomers}}
													</div> 
													<div class="column is-6 pd-y-1">
														<span class="has-text-weight-semibold">Service charge per customers:</span> {{item.serviceChargePerCustomers | comma}} {{(item.serviceChargePerCustomers !== '')?'THB':'-'}}
													</div>    
												</div>  
											</div>
										</div>  
									</div>
								</div>
								<div >
									<h3 class="has-text-weight-semibold is-size-5 has-text-dark is-flex is-align-end is-justify-start">Team member</h3>	
									<div v-for="(item,index) in companyInvest.team" :key="index" class="pd-4">
										<div class="is-flex-wrap columns pd-5">
											<div class="column is-3">
												<label for="uploadfile">
													<div class="circle-img-small" v-if="item.profilePhotoTeam !== '' && item.profilePhotoTeam.length !== 0">
														<img   v-if="typeof item.profilePhotoTeam[0] === 'undefined'" class="haveimg" :src="imgUat+companyInvest.companyId+'/'+item.profilePhotoTeam.name" />
														<img   v-else class="haveimg" :src="imgUat+companyInvest.companyId+'/'+item.profilePhotoTeam[0].name" />
													</div>
													<div v-if="item.profilePhotoTeam.length == ''" class="noimg img-size-100">
														<p>100 x 100</p>
													</div>
												</label>
											</div>
											<div  class="column is-9">			
												<div class="columns is-flex-wrap">
													<div class="column is-6">
														<span class="has-text-weight-semibold">Name:</span> {{item.englishNameTeam}}
													</div> 
													<div class="column is-6">
														<span class="has-text-weight-semibold">Position:</span> {{item.positionMember}}
													</div> 
													<div class="column is-6">
														<span class="has-text-weight-semibold">Linkedin:</span> {{item.linkedinTeam}}
													</div>  
												</div>  
											</div>
										</div>  
									</div>
								</div>
								<div >
									<h3 class="has-text-weight-semibold is-size-5 has-text-dark is-flex is-align-end is-justify-start">Sponsor</h3>	
									<div  class="pd-4">
										<div class="is-flex-wrap columns pd-5 is-vcentered" >
											<div class="column is-3" v-for="(item,index) in companyInvest.other" :key="index">
												<label for="uploadfile">
													<div v-if="item.logoDepartmentInvertor !== '' && item.logoDepartmentInvertor.length !== 0" class="has-text-centered">
														<div class="square-img-small" >
															<img  v-if="typeof item.logoDepartmentInvertor[0] === 'undefined'" class="haveimg" :src="imgUat+companyInvest.companyId+'/'+item.logoDepartmentInvertor.name" />
															<img  v-else class="haveimg" :src="imgUat+companyInvest.companyId+'/'+item.logoDepartmentInvertor[0].name" />
														</div>
														<p>{{item.departmentNameEng}}</p>
													</div>
													<div v-if="item.logoDepartmentInvertor.length == ''" class="has-text-centered">
														<div  class="noimg-square img-size-100">
															<p>100 x 100</p>
														</div>
														<p>{{item.departmentNameEng}}</p>
													</div>

												</label>
											</div>
										</div>  
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
     </div>
 </template>
 
<script>
import { HTTPMentor } from "@/axios";
export default {
	name:'InvestCompanyDetail',
	data() {
		return {
			imgPath: process.env.VUE_APP_IMAGE_URL_INTEGREAT,
			imgUat: process.env.VUE_APP_IMAGE_URL_DYNAMIC,
			interest:false,
			isLoadingPage:false
		}
	},
	computed: {
		companyInvest(){
			return this.$store.state.companyInvest
		},
		islogin(){
			return this.$store.state.islogin
		}
	},
	mounted() {
		this.isLoadingPage = true
		this.checkInterest()
	},
	methods: {
		checkInterest(){
			let obj ={
				userId:this.islogin.userId,
				companyId:this.companyInvest.companyId,
				batchId:this.companyInvest.batch.batchId
			}
			HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.islogin.token}`;
			HTTPMentor.post(`api/check/interest`,obj)
            .then(res => {
              console.log('api/check/interest', res.data)
              if(res.data.success){
				  	this.interest = true
               }else{
					this.interest = false
			  }
				setTimeout(() => {
						this.isLoadingPage = false
					}, 500);
				})
            .catch(e => {
				setTimeout(() => {
					this.isLoadingPage = false
				}, 500);
              console.log("api/check/interest/error",e);
            });
		},
		viewContact(){
			this.isLoadingPage = true
			let obj ={
				userId:this.islogin.userId,
				interest:[{
					companyId:this.companyInvest.companyId,
					batchId:this.companyInvest.batch.batchId
				}]
			}
			HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.islogin.token}`;
			HTTPMentor.post(`api/interest/company`,obj)
            .then(res => {
              console.log('api/interest/company', res.data)
              if(res.data.success){
				this.checkInterest()
			   }else{
				   this.$dialog.alert('Failed. Please try again by signout or cache refresh.')
			   }
			   
			   setTimeout(() => {
				   this.isLoadingPage = false
			   }, 500);
			   
            })
            .catch(e => {
				setTimeout(() => {
					this.isLoadingPage = false
				}, 500);
				this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
              console.log("api/interest/company/error",e);
            });
		},
		getTextCheckBox(data){
			let text = ''
			data.map((item,index)=>{
				let comma = (index !== 0)?', ':''
				text = text+comma+item.label
			})
			return text
		}
	},
}
</script>


<style  scoped>
	.circle-img{
		width:170px;
		height:170px;
		overflow:hidden;
		display:flex;
		border-radius: 100%;
		justify-content: center;
		align-content: center;
		margin-left:auto;
		margin-right:auto;
		box-shadow: 0px 5px 5px 0px rgba(237,237,237,1)!important;
	}
	.circle-img img,.circle-img-small img,.square-img-small img,.square-img img{
		max-width:100%;
	}
	.circle-img-small{
		width:100px;
		height:100px;
		overflow:hidden;
		display:flex;
		border-radius: 100%;
		justify-content: center;
		align-content: center;
		margin-left:auto;
		margin-right:auto;
		box-shadow: 0px 5px 5px 0px rgba(237,237,237,1)!important;
	}
	.square-img{
		width:170px;
		height:170px;
		overflow:hidden;
		display:flex;
		justify-content: center;
		align-content: center;
		margin-left:auto;
		margin-right:auto;
	}
	.square-img-small{
		width:100px;
		height:100px;
		overflow:hidden;
		display:flex;
		justify-content: center;
		align-content: center;
		margin-left:auto;
		margin-right:auto;
		overflow: hidden;
	}
	.box-page{
		border: 1px solid #ebebeb;
	    border-radius: 5px;
	    background: white;
	}
	div.control {
	    width: 100%;
	    display: inline-block;
	}
	.noimg{
		border: 1px solid;
		display:flex;
		border-radius: 100%;
		justify-content: center;
		align-items: center;
		margin-left:auto;
		margin-right:auto;
	}
	.noimg-square{
		border: 1px solid;
		display:flex;
		justify-content: center;
		align-items: center;
		margin-left:auto;
		margin-right:auto;
	}
	.img-size-170{
		width:170px;
		height:170px;
	}
	.img-size-100{
		width:100px;
		height:100px;
	}
</style>
